// extracted by mini-css-extract-plugin
export default {"container":"live_container__LIJYg","logo":"live_logo__OFMWg","avatar":"live_avatar__m8FmR"};